import { API_BASE_URL, apiRequest, getAuthHeaders, ApiResponse } from "../client";

export interface InitiateCallPayload {
  loan_application_id: number;
  repayment_id: number;
  contact_type: number;
}

export interface InitiateCallResponse {
  success: boolean;
  message: string;
  reference_id: string;
  telecmi_request_id: string;
  loan_application_id: number;
  contact_type: number;
  outbound_call_request_id: number;
}

export type CallingType = "pre" | "post";

export interface OutboundCallSummary {
  outbound_call_request_id: number;
  loan_application_id: number;
  applicant_id: string;
  status: string | null;
  call_start_time: string | null;
  call_end_time: string | null;
  duration_seconds: number | null;
  /**
   * From GET /calling/outbound/{id}.
   * today <= demand_date → "pre"; today > demand_date → "post".
   * null when no matching demand date for the loan.
   * Do not confuse with status-management calling_type (1 contact / 2 demand).
   */
  calling_type: CallingType | null;
}

/** Map API calling_type to UI mode. null → "post" default. */
export function normalizeCallingType(
  value: CallingType | null | undefined
): CallingType {
  return value === "pre" ? "pre" : "post";
}

export const CallingService = {
  async initiateCall(
    payload: InitiateCallPayload
  ): Promise<ApiResponse<InitiateCallResponse>> {
    return apiRequest<InitiateCallResponse>(`${API_BASE_URL}/calling/initiate`, {
      method: "POST",
      headers: getAuthHeaders(),
      body: JSON.stringify(payload),
    });
  },

  async getOutboundSummary(
    outboundCallRequestId: number
  ): Promise<OutboundCallSummary | null> {
    const response = await fetch(
      `${API_BASE_URL}/calling/outbound/${outboundCallRequestId}`,
      {
        headers: getAuthHeaders(),
      }
    );

    if (!response.ok) {
      throw new Error(`Failed to fetch outbound summary: ${response.status}`);
    }

    const data = (await response.json()) as OutboundCallSummary | null;
    return data;
  },
};

